import { createSelector } from 'reselect';

import getPopupState from '@r1-frontend/bp42/selectors/getPopupState';
import isInitialized from '@r1-frontend/bp42/selectors/isInitialized';

const selectDataForMainPopup = createSelector([
    isInitialized,
    getPopupState,
], (initialized, isPopupOpen) => ({
    initialized,
    isPopupOpen,
}));

export default selectDataForMainPopup;
